import * as a9 from '../analytics'
import { ErrorResponse } from '../types/api'

import { handleRedirectOnUnauth } from '../business'
import * as api from './index'

interface ErrorAuthRequestParams extends a9.BaseParams, ErrorResponse {
  status: number
}

export const authFetch = async (url: string, options: RequestInit = {}) => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
  })

  if (!response.ok && response.status === 401) {
    const error = await response.json()
    if (error.code === 'NotAuthorizedException') {
      a9.dispatchEvent(a9.Event.ERROR_AUTH_REQUEST, {
        ...error,
        status: response.status,
      } as ErrorAuthRequestParams)

      await api.clearSession()
      handleRedirectOnUnauth()
    }
  }

  return response
}

export default authFetch
